import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import styled from "styled-components";
import Colors from "@constants/Colors";

export const StyledRootBox = styled(Box)`
  display: flex !important;
  flex-direction: column !important;
  padding: 16px !important;

  gap: 8px !important;
  background: ${Colors.white} !important;
  border: 1px solid ${Colors.neutral_gray_300} !important;
  border-radius: 12px !important;
`;

export const StyledSalesBox = styled(Box)`
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  padding: 0px !important;
  width: 48%;
`;

export const StyledSalesRow = styled(Box)`
  display: flex !important;
  justify-content: space-between !important;
  padding: 8px 0px !important;
`;

export const StyledTitle = styled(Typography)<{ color: string }>`
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  display: flex !important;
  align-items: center !important;
  color: ${({ color }: { color: string }) => color};
`;

export const StyledTypographySales = styled(Typography)<{ background: string }>`
  width: fit-content !important;
  border-radius: 4px !important;
  padding: ${({ background }: { background: string }) =>
    background.length > 0 ? "0px 8px" : "0px"} !important;
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  display: flex !important;
  align-items: center !important;
  color: ${Colors.neutralblack};
`;

export const StyledValue = styled(Typography)`
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  display: flex !important;
  align-items: center !important;
  min-width: 40px;
  color: ${Colors.neutral_gray_900};
  word-break: break-word;
  max-width: 6rem;

  @media (min-width: 600px) {
    max-width: 16rem;
  }

  @media (min-width: 769px) {
    max-width: 6rem;
  }
`;

export const StyledValueBox = styled(Box)`
  display: flex !important;
  gap: 8px !important;
`;

export const Legend = styled("div")<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor || "#FFF"};
  width: 12px;
  height: 12px;
  border-radius: 2px;
`;

export const LegendBox = styled("div")`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
